import { isMobile } from "react-device-detect";
import token_icon from "assets/token.svg";
import { ITokenPackage } from "services/api/tokenApi";
import styled from "styled-components";
import  Spinner  from 'ui-kit/Spinner';

interface IPlanCardProps {
  plan: ITokenPackage;
  selected: boolean;
  onSelect: ((plan: ITokenPackage | null) => void) | null;
  isLoading?: boolean;
}

const PlanCard: React.FC<IPlanCardProps> = ({ plan, selected, onSelect, isLoading = false }) => {
  const handleSelect = () => {
    if (isLoading || !onSelect) return;

    if (selected) {
      onSelect(null);
    } else {
      onSelect(plan);
    }
  };

  const getFormattedCurrency = (currency: string) => {
    if (currency === 'USD') {
      return '$';
    }
    return currency;
  };
  return (
    <Root selected={selected || isLoading} onClick={handleSelect}>
      {isLoading ? (
        <LoaderOverlay>
          <Spinner size={30} />
        </LoaderOverlay>
      ) : (
        <>
          {plan.bonusTokenOffer && <BonusSection>{plan.bonusTokenOffer}</BonusSection>}
          <TokensWrapper>
            <AnimationWrapper>
              {!isMobile && <BuyText>Buy</BuyText>}
              <Tokens>
                <TokenIcon src={token_icon} />
                {plan.tokensAmount}
              </Tokens>
            </AnimationWrapper>
          </TokensWrapper>
          <Price>
            {plan.strikethroughPrice && <InitialPrice>{`${getFormattedCurrency(plan.currency)}${plan.strikethroughPrice}`}</InitialPrice>}
            {plan.strikethroughPrice && " "}
            {getFormattedCurrency(plan.currency)}{plan.price}
          </Price>
          {plan.discountPriceOffer && <SpecialOffer>{plan.discountPriceOffer}</SpecialOffer>}
        </>
      )}
    </Root>
  );
};

export default PlanCard;

const Root = styled.div<{ selected: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 74px;
  padding: 16px;
  gap: 4px;
  border-radius: 12px;
  background: ${({ selected }) => (selected ? "#FF7E55" : "#131313")};
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.4s ease-in-out;

  &:hover {
    transform: scale(1.02);
    background: ${({ selected }) => (selected ? "#FF7E55" : "#463732")};
    border: 1px solid #FF7E55;
  }
`;

const TokensWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const AnimationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  transform: translateX(0);
  opacity: 0.85;
  transition: all 0.5s ease;

  ${Root}:hover &, ${Root}[selected=true] & {
    transform: translateX(0);
    opacity: 1;
  }
`;

const BuyText = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.5s ease-in-out;

  ${Root}:hover &, ${Root}[selected=true] & {
    max-width: 50px;
    margin-right: 4px;
  }

  @media (max-width: 420px) {
    font-size: 12px;
  }
`;

const Tokens = styled.div`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 420px) {
    font-size: 14px;
  }
`;

const Price = styled.div`
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;

  @media (max-width: 420px) {
    font-size: 10px;
  }
`;

const TokenIcon = styled.img`
  width: 20px;
  height: 20px;

  @media (max-width: 420px) {
    width: 16px;
    height: 16px;
  }
`;

const InitialPrice = styled.span`
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-decoration-line: line-through;
  opacity: 0.6;
`;

const SpecialOffer = styled.span`
  width: 41px;
  height: 24px;
  padding: 2px 6px 2px 6px;
  gap: 10px;
  border-radius: 12px 0px 12px 0px;
  background: #FF7E55;
  font-family: Nunito Sans;
  font-size: 11px;
  font-weight: 700;
  line-height: 12px;
  color: #fff;
  position: absolute;
  right: -1px;
  bottom: -1px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 420px) {
    width: 36px;
    height: 20px;
    font-size: 10px;
  }
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const BonusSection = styled.div`
  padding: 2px 6px 2px 6px;
  gap: 10px;
  border-radius: 6px;
  background: #FF7E55;
  font-family: Nunito Sans;
  font-size: 11px;
  font-weight: 700;
  line-height: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-150%);

  @media (max-width: 420px) {
    font-size: 10px;
  }
`;